// Tasks Module
// Módulo independiente de gestión de tareas clínicas.
// Documentación: docs/modulos/16-tasks.md
// Endpoints: docs/modulos/04_TASKS_ENDPOINTS_GUIDE.md

import TasksPage from "./pages/TasksPage";

export { TasksPage };

export const tasksRoutes = [
  { path: "/tasks", element: <TasksPage /> },
];
